/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetAvailableUsStates$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAvailableUsStatesRequest = createAction<PayloadData<void>>('GET_AVAILABLE_US_STATES__GET_AVAILABLE_US_STATES__REQUEST');
export const getAvailableUsStatesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_AVAILABLE_US_STATES__GET_AVAILABLE_US_STATES__SUCCESS');
export const getAvailableUsStatesFailure = createAction<PayloadData<Error, void, true>>('GET_AVAILABLE_US_STATES__GET_AVAILABLE_US_STATES__FAILURE');

export const getAvailableUsStatesActions = [
    getAvailableUsStatesRequest,
    getAvailableUsStatesSuccess,
    getAvailableUsStatesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAvailableUsStates = (config?: GetAvailableUsStates$Config) => {
    return {
        CALL_API: {
            types: getAvailableUsStatesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/us-states`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

